import React from 'react'
import { history } from 'store/store'
import DeleteIcon from '@material-ui/icons/Delete'
import { Button } from 'components/buttons'

export const TrashButton = ({ canGoToTrash, goToTrashUrl, goToTrashDisabled, localize, metadata, canCreate }) => {
  const trashUrl = goToTrashUrl || `${metadata.urls.base}/trash`
  const handleGoToTrash = React.useCallback(() => history.push(trashUrl), [trashUrl])
  if (canGoToTrash) {
      return (
        <Button icon={<DeleteIcon />} disabled={goToTrashDisabled} color='secondary' onClick={handleGoToTrash} marginLeft={canCreate ? 10 : 0}>{localize('common.trash')}</Button>
      )
    }
    return null
}
